// Async bootstrap to guarantee MF share scope is initialized before any sync imports
import('./bootstrap');


